import React, { Component, Suspense, lazy } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import SaayaLogo from '../../static/images/saayalogo.svg';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
import { authActions, AppVersionActions } from '../../store/actions';
import { history } from '../../helpers/history';
import Swal from 'sweetalert2';
import red from '@material-ui/core/colors/red';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import { WhitelabelActions } from '../../store/actions';
import { constants } from '../../Constants';

const defaultImage = lazy(() => import('../../static/images/default_BG.png'));
const Image = lazy(() => import('../../components/Image/index'));
class HeaderComponent extends Component {
	state = {
		anchorEl: null,
	};

	componentWillMount() {
		this.props.fetchAppVersion();
	}

	home = () => {
		history.push('/home');
	};
	SignOut = () => {
		history.push('/');
		this.props.logout();
	};

	openMyCounsellor = () => {
		history.push('/my-counsellor');
	};

	openMyPatient = () => {
		history.push('/my-patients');
	};

	changePassword = async () => {
		const { value: formValues } = await Swal.fire({
			title: constants.CHANGE_PASSWORD_TXT,
			showCancelButton: true,
			confirmButtonText: constants.CHANGE_PASSWORD_TXT,
			cancelButtonText: constants.CANCEL_TXT,
			confirmButtonColor: '#309583',
			cancelButtonColor: '#C62E2E',
			html:
				'<input id="swal-input1" type="password" placeholder="Old Password" class="swal2-input">' +
				'<input id="swal-input2" type="password" placeholder="New Password" class="swal2-input">' +
				'<input id="swal-input3" type="password" placeholder="Confirm Password" class="swal2-input">' +
				'',
			focusConfirm: false,
			type: constants.INFO_TXT,
			reverseButtons: true,

			preConfirm: () => {
				return [
					document.getElementById('swal-input1').value,
					document.getElementById('swal-input2').value,
					document.getElementById('swal-input3').value,
				];
			},
		});

		if (formValues) {
			const data = formValues;
			const { dispatch } = this.props;
			if (data[0] === '' || data[1] === '' || data[2] === '') {
				Swal.fire({
					type: constants.ERROR_TEXT,
					title: constants.SAAYA_HEALTH_TXT,
					text: constants.FILL_ALL_FIELDS_MSG,
					confirmButtonText: constants.OK_TXT,
				});
			} else {
				if (data[1] === data[2]) {
					this.props.changePassword(data[0], data[2]);
				} else {
					Swal.fire({
						type: constants.ERROR_TEXT,
						title: constants.WRONG_PASSWORD_TXT,
						text: constants.PASSWORD_MISMATCH_TXT,
						confirmButtonText: constants.OK_TXT,
					});
				}
			}
		}
	};

	handleClick = (event) => {
		this.setState({
			anchorEl: event.currentTarget,
		});
	};

	handleClose = () => {
		this.setState({
			anchorEl: null,
		});
	};
	render() {
		let user_info = localStorage.getItem('user');
		let relation = user_info ? JSON.parse(user_info).has_relation : ''; //this.SignOut();
		let role = user_info ? JSON.parse(user_info).role : null;
		const { anchorEl } = this.state;
		const { user, whitelabel } = this.props;

		const open = Boolean(anchorEl);
		return (
			<div className="skin-blue">
				<header className="main-header">
					<div className="row">
						<div className="w-75 mx-auto">
							<div className="d-flex header-child">
								{' '}
								<div onClick={this.home}>
									<Suspense
										fallback={
											<div className="header-logo">
												<div className="loader-wrapper" style={{ position: 'inherit' }}>
													<div className="loader"></div>
												</div>
											</div>
										}
									>
										<section>
											<Image
												cssClass={'header-logo'}
												src={ SaayaLogo}
												alt="SaayaHealth logo"
											/>
										</section>
									</Suspense>
								</div>
								<div className="ml-auto pt-1 m-3">
									<h2 className="marginTop25">{constants.ADMIN_PANEL_TXT}</h2>
								</div>
								<div className="ml-auto pt-1 m-3">
									<div className="icons row">
										<i
											className="fas fa-user-circle m-3 userIcon"
											aria-owns={open ? 'simple-popper' : undefined}
											aria-haspopup="true"
											variant="contained"
											onClick={this.handleClick}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</header>
				<div>
					<Popover
						id="simple-popper"
						open={open}
						anchorEl={anchorEl}
						onClose={this.handleClose}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'center',
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
					>
						<Typography component={'span'} className="typography">
							<Card>
								<CardHeader
									avatar={<i className="fas fa-user-circle icons" style={{ color: '#3157A8' }} />}
									title={
										<div className="logoutName">
											{user && user.username && user.username.toUpperCase()}
										</div>
									}
									subheader={<div>{user && user.email_address}</div>}
								/>
								<CardContent>
									{/* {relation !== null && relation !== false ? (
										role === 1 ? (
											<div>
												<Button size="small" variant="outlined" onClick={this.openMyCounsellor}>
													My{' '}
													{whitelabel && whitelabel[0]
														? whitelabel[0].producer_role
														: constants.COUNSELLOR}
												</Button>
											</div>
										) : (
											<div>
												<Button size="small" variant="outlined" onClick={this.openMyPatient}>
													My{' '}
													{whitelabel && whitelabel[0]
														? whitelabel[0].consumer_role
														: constants.STUDENT}
												</Button>
											</div>
										)
									) : null} */}
									{/* <div className="mui-buttons">
										<Button
											variant="outlined"
											className="change-password-alignment"
											size="small"
											onClick={this.changePassword}
										>
											Change Password
											<i className="fa fa-lock pl-1" />
										</Button>
									</div> */}
									<div className="mui-buttons">
										<Button variant="outlined" size="small" onClick={this.SignOut}>
											Logout
											<i className="fa fa-sign-out-alt pl-1" />
										</Button>
									</div>
								</CardContent>
							</Card>
						</Typography>
					</Popover>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	const { alert } = state;
	const { users, auth } = state;
	const { whitelabel } = state.whitelabel;
	const { user } = auth;
	return {
		alert,
		user,
		whitelabel,
		users,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		fetchWhitelabel: () => {
			dispatch(WhitelabelActions.fetchWhitelabel());
		},
		logout: () => {
			dispatch(authActions.logout());
		},
		changePassword: (data1, data2) => {
			dispatch(authActions.changePassword(data1, data2));
		},
		fetchAppVersion: () => dispatch(AppVersionActions.fetchAppVersion())
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderComponent));



// WEBPACK FOOTER //
// ./src/components/Header/index.js